module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-36.8a57dd0d.png";